import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '$partials/ui';
import { Image } from '$partials/media';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ExpertiseItem = ({
    headingImage = null,
    listingImage = null,
    title        = null,
    url          = null
}) => {
    // misc
    const image = listingImage || headingImage || null;

    // render
    return (
        <div className='expand-interaction hover-image-scale'>
            <Button
                className='expand-interaction__action'
                href={url}>
                <div
                    className='rich-text type-style-3'
                    dangerouslySetInnerHTML={{__html: title}} />
            </Button>

            {image && (
                <figure className='border-rad-10 font-0 mt6 md-mt7'>
                    <Image
                        {...image}
                        containerClassName='hover-image-scale-target' />
                </figure>
            )}
        </div>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

ExpertiseItem.propTypes = {
    headingImage: PropTypes.object,
    listingImage: PropTypes.object,
    title:        PropTypes.string,
    url:          PropTypes.string,
};

ExpertiseItem.__typename = 'Expertise';

export { ExpertiseItem };

export default ExpertiseItem;
